<template lang='pug'>
#main
  input(
    type="file",
    @change="handleFileChange",
    ref="eventoClick",
    multiple="false",
    style="display:none",
    accept=".sicarf"
  )
  div.upload-sicarf(
    @click="callEventClick()",
    @dragenter.prevent="onDragEnter",
    @dragover.prevent="onDragOver",
    @dragleave="onDragLeave",
    @drop.prevent="onDrop",
    :class="{ 'drag-over': isDragging }"
  )
    .upload-content
      i.icon-upload.el-icon-upload
      p.tip-upload Arraste ou clique aqui para enviar o arquivo
  ul(:class="['el-upload-list', 'el-upload-list--text']", name="el-list")
    li(
      v-for="(file, index) in fileList",
      :class="['el-upload-list__item']",
      :key="file.name",
      tabindex="0"
    )
      a(class="el-upload-list__item-name")
        i(class="el-icon-document")
        | {{file.name}}
      i(class="el-icon-close", @click.stop="removeFile()")
</template>

<script>
import * as tus from 'tus-js-client'

export default {
  data () {
    return {
      fileAdded: null,
      isDragging: false
    }
  },
  props: {
    target: {
      type: String,
      required: true
    }
  },
  computed: {
    fileList () {
      return this.fileAdded ? [this.fileAdded] : []
    }
  },
  methods: {
    callEventClick () {
      this.$refs.eventoClick.click()
    },
    removeFile () {
      if (this.fileAdded !== null) {
        this.fileAdded = null
      }
    },
    handleFileChange (files) {
      const file = files.target.files[0]
      if (file) {
        this.fileAdded = file
        this.startUpload(file)
      }
    },
    startUpload (file) {
      this.$emit('fileProgress')
      const upload = new tus.Upload(file, {
        endpoint: this.target,
        retryDelays: [0, 3000, 6000, 12000, 24000],
        chunkSize: 1000000, // 1MB
        metadata: {
          filename: file.name,
          filetype: file.type
        },
        onError: (error) => {
          this.$emit('onError', error)
        },
        onProgress: (bytesUploaded, bytesTotal) => {
          const percentage = ((bytesUploaded / bytesTotal) * 100).toFixed(2)
          this.$emit('onProgress', percentage)
        },
        onSuccess: () => {
          this.$emit('onSuccess', upload.file, upload.file.name)
          this.fileAdded = null
        }
      })
      upload.start()
    },
    onDragEnter () {
      this.isDragging = true
    },
    onDragOver () {
      this.isDragging = true
    },
    onDragLeave () {
      this.isDragging = false
    },
    onDrop (event) {
      this.isDragging = false
      const file = event.dataTransfer.files[0]
      if (file) {
        this.fileAdded = file
        this.startUpload(file)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.upload-sicarf {
  font-size: 1.2em;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  text-align: center;
  height: inherit;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    border-color: #009f61;
  }

  &.drag-over {
    border-color: #009f61;
    background-color: rgba(0, 159, 97, 0.1);
  }
}

.icon-upload {
  font-size: 67px;
}

.upload-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.tip-upload {
  font-size: 1em;
}

.el-icon-close {
  cursor: pointer;
  color: red;
  margin-left: 10px;

  &:hover {
    opacity: 0.8;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Importacao/UploadCadastro.vue